import * as _ from 'lodash';

export const trimEnd = (val) => _.replace(val, /\s{1,}$/gi, '');